<template>
  <div class="container mt-4">
    <div class="row g-3">
      <div class="col-md-4 col-sm-6 mb-3" v-for="documento in aniosDocumento" :key="documento.id">
        <div class="card h-100 shadow-sm documento-card">
          <div class="card-body d-flex align-items-start">
            <!-- Icono de Font Awesome -->
            <i style="color:#621132!important;" class="fas fa-file-alt fa-2x text-secondary me-4"></i> <!-- Cambié el margen a "me-4" para mayor separación -->
            <div>
              <!-- Información del documento -->
              <p class="card-title fw-bold">
                <strong>Nombre: </strong> 
                <span class="text-color-documento">{{ documento.titulo }}</span> <!-- Cambié el color del título -->
              </p>
              <p class="card-text"><strong>Tipo:</strong> Documento HTML</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    aniosDocumento: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
/* Color personalizado para el título del documento y texto */
.text-color-documento {
  color: #621132; /* Cambié el color al solicitado */
}

/* Espaciado extra entre el icono y el texto */
.card-body i {
  margin-right: 1.5rem; /* Separa más el icono del texto */
}

/* Hover efecto en la tarjeta */
.documento-card {
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.documento-card:hover {
  transform: scale(1.1); /* Efecto de escala al pasar el mouse */
  background-color: rgba(98, 17, 50, 0.1); /* Color de fondo al hacer hover */
}
</style>
